import CreateColumn from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('userNm', '성명', 'left', 120, false, false, false, 'text', {
      maxWidth: 120,
      editable: false,
      cellClass: 'none-editable-cell',
    }),

    CreateColumn(
      'depNm',
      '소속(팀명)',
      'left',
      120,
      false,
      false,
      false,
      'text',
      {
        maxWidth: 120,
        editable: false,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn('position', '직급', 'left', 120, false, false, false, 'text', {
      maxWidth: 120,
      editable: false,
      cellClass: 'none-editable-cell',
    }),

    CreateColumn(
      'etcEduNm',
      '교육명',
      'left',
      120,
      false,
      false,
      false,
      'text',
      {
        minWidth: 500,
        flex: 3,
        editable: false,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn(
      'eduCount',
      '등록교육수',
      'right',
      120,
      false,
      false,
      false,
      'number',
      {
        maxWidth: 120,
        editable: false,
        valueFormatter: (params) => params.value || 0,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn(
      'completeCount',
      '이수완료건',
      'right',
      120,
      false,
      false,
      false,
      'number',
      {
        maxWidth: 120,
        editable: false,
        valueFormatter: (params) => params.value || 0,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn(
      'noCompleteCount',
      '미이수건',
      'right',
      120,
      false,
      false,
      false,
      'number',
      {
        maxWidth: 120,
        editable: false,
        valueFormatter: (params) => params.value || 0,
        cellClass: 'none-editable-cell',
      }
    ),
    CreateColumn(
      'alarmYn',
      '알람여부',
      'center',
      120,
      true,
      false,
      false,
      'select',
      {
        maxWidth: 120,
        selectOptions: ['Y', 'N'],
        cellEditorParams: {
          values: ['Y', 'N'],
        },
        valueSetter: (params) => {
          params.data.alarmYn = params.newValue;
          params.data.editYn = 'Y';

          if (params.newValue === 'Y' || params.newValue === 'y') {
            if (!params.data.alarmGubun || params.data.alarmGubun === '') {
              params.node.setDataValue('alarmGubun', '0');
              params.data.alarmGubun = '0';
            }
          }
          if (params.newValue === 'N' || params.newValue === 'n') {
            params.node.setDataValue('alarmGubun', '');
            params.data.alarmGubun = '';
          }

          return true;
        },
      }
    ),
    CreateColumn(
      'alarmGubun',
      '알람구분',
      'center',
      120,
      true,
      false,
      false,
      'select',
      {
        maxWidth: 120,
        selectOptions: ['7일전', '3일전', '1일전'],
        editableCondition: (params) => {
          return params.data?.alarmYn === 'Y';
        },
        valueFormatter: (params) => {
          if (!params.value) return '';
          const codeMap = {
            0: '7일전',
            1: '3일전',
            2: '1일전',
          };
          return codeMap[params.value] || params.value;
        },
        valueParser: (params) => {
          if (!params.newValue) return '';
          const nameMap = {
            '7일전': '0',
            '3일전': '1',
            '1일전': '2',
          };
          return nameMap[params.newValue] || params.newValue;
        },
        valueSetter: (params) => {
          const nameMap = {
            '7일전': '0',
            '3일전': '1',
            '1일전': '2',
          };
          params.data.alarmGubun = nameMap[params.newValue] || params.newValue;
          params.data.editYn = 'Y';
          return true;
        },
        customCellStyle: (params) => {
          const isEditable = params.data?.alarmYn === 'Y';
          return {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: isEditable ? 'white' : '#f5f5f5',
            color: isEditable ? 'inherit' : '#666',
            fontStyle: isEditable ? 'normal' : 'italic',
            cursor: isEditable ? 'pointer' : 'not-allowed',
          };
        },
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
